const PREFIX = 'CONFIG_';

export const GET_ALL_PACKAGES_REQUEST = `${PREFIX}GET_ALL_PACKAGES_REQUEST`;
export const GET_ALL_PACKAGES_SUCCESS = `${PREFIX}GET_ALL_PACKAGES_SUCCESS`;
export const GET_ALL_PACKAGES_ERROR = `${PREFIX}GET_ALL_PACKAGES_ERROR`;
